import React from 'react';
import { useField, UseFieldConfig } from 'react-final-form';
import { ErrorText } from '../Input';
import { WysiwygEditor } from '../WysiwgEditor';

type WysiwygEditorFieldProps = Omit<
  React.ComponentProps<typeof WysiwygEditor>,
  'onChange'
> & {
  name: string;
  validate?: UseFieldConfig<string>['validate'];
  dontSaveSpaceForErrorText?: boolean;
};

export function WysiwygEditorField({
  dontSaveSpaceForErrorText = false,
  initialValue,
  name,
  validate,
  ...rest
}: WysiwygEditorFieldProps) {
  const { input, meta } = useField<string>(name, { validate, initialValue });

  const errorId = `${name}-error`;

  return (
    <>
      <WysiwygEditor
        {...rest}
        aria-describedby={errorId}
        initialValue={input.value}
        onChange={input.onChange}
      />
      <input type="hidden" name={name} />
      <ErrorText id={errorId}>
        {meta.error || (dontSaveSpaceForErrorText ? '' : ' ')}
      </ErrorText>
    </>
  );
}
